import _ from "lodash";
import * as React from "react";
import { IFormFieldProps } from "./IFormField";
import { FormField, FormFieldProps } from "../../editors";
import { WrapperLess } from "../../generic";
import * as Forms from "../../../forms";
import * as M from "../../../models";

type OwnProps = IFormFieldProps & {
};

interface OwnState {
    openAnswer: { [index: number ]: boolean; };
}

export class SelectListField extends React.Component<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            openAnswer: {},
        };
    }

    public render() {
        const f = this.props.field;
        const name = M.FormBuilder.FormSubmissionHelper.getFieldName(this.props.namePrefix || "", this.props.sectionIndex, f.index);
        // const values = this.props.formComponent.getFieldValue(name) as Forms.FormBuilder.FormFieldOptionAnswerData[];

        const formFieldProps: FormFieldProps = {
            description: f.description
                ? <div dangerouslySetInnerHTML={{ __html: f.description }} />
                : undefined,
            errors: this.props.formComponent.getFieldErrors(name),
            hint: f.hint,
            label: f.label,
            name,
            required: f.required,
        };

        const options = f.typeId === M.FormBuilder.FieldTypes.Dropdown.id
            ? (f.options || []).map((opt, i) => <option key={i} value={opt.optionId}>{opt.label}</option>)
            : (f.options || []).map((opt, i) => {
                const optName = M.FormBuilder.FormSubmissionHelper.getFieldOptionName(this.props.namePrefix || "", this.props.sectionIndex, f.index, opt.index);
                const openAnswer = this.getOpenAnswer(opt);
                const type = f.typeId === M.FormBuilder.FieldTypes.CheckList.id ? "checkbox" : "radio";

                return <li key={i}>
                    <label>
                        <input
                            type={type}
                            name={`${optName}.selected`}
                            checked={opt.selected}
                            onChange={(e) => this.handleOptionChange(e, opt)}
                        />
                        <span dangerouslySetInnerHTML={{ __html: opt.label }} />
                    </label>
                    {openAnswer}
                </li>;
            });

        const selectedOptions = (f.options || []).filter((opt) => opt.selected);
        const selectList = f.typeId === M.FormBuilder.FieldTypes.Dropdown.id
            ? <select
                className={f.css}
                value={selectedOptions.length ? selectedOptions[0].optionId : undefined}
                onChange={(e) => this.handleDropdownChange(e)}
            >
                {options}
            </select>
            : <ul className={f.css}>
                {options}
            </ul>;

        const dropOpenAnswers = f.typeId === M.FormBuilder.FieldTypes.Dropdown.id
            ? <WrapperLess>
                {(f.options || []).filter((opt) => opt.isOpenAnswer).map((opt, i) => this.getOpenAnswer(opt, i))}
            </WrapperLess>
            : null;

        return <FormField { ...formFieldProps }>
            {selectList}
            {dropOpenAnswers}
        </FormField>;
    }

    private getOpenAnswer(option: Forms.FormBuilder.FormFieldOptionData, key?: number) {
        const optName = M.FormBuilder.FormSubmissionHelper.getFieldOptionName(this.props.namePrefix || "", this.props.sectionIndex, this.props.field.index, option.index);
        // const openAnswerShown = this.state.openAnswer[option.optionId];
        const openAnswerHint = option.openAnswerHint
            ? <div className="field-help">{option.openAnswerHint}</div>
            : null;

        if (!(option.isOpenAnswer && option.selected)) // && openAnswerShown))
            return null;

        const errors = this.props.formComponent.getFieldErrors(`${optName}.openAnswer`);

        return <div className={errors.length ? "field-with-errors" : ""} key={key}>
                <input
                    className="txt"
                    name={`${optName}.openAnswer`}
                    placeholder={option.openAnswerPlaceholder}
                    type="text"
                    value={option.openAnswer || ""}
                    onChange={() => {}}
                />
                {openAnswerHint}
                {errors.length
                    ? <div className="field-errors">{errors.map((e, i) => <div className="error" key={i}>{e}</div>)}</div>
                    : null}
            </div>;
    }

    private handleDropdownChange(e: React.ChangeEvent<HTMLSelectElement>) {
        const val = e.target.value;
        const optionId = val ? parseInt(val, 10) : 0;
        this.updateOption(optionId, true);
    }

    private handleOptionChange(e: React.ChangeEvent<HTMLInputElement>, option: Forms.FormBuilder.FormFieldOptionData) {
        this.updateOption(option.optionId, e.target.checked);

        // if (option.isOpenAnswer) {
        //     const openAnswer = this.state.openAnswer;
        //     openAnswer[option.optionId] = e.target.checked;
        //     this.setState({ ...this.state, openAnswer });
        // }

        // if (this.props.field.typeId === M.FormBuilder.FieldTypes.CheckList.id) {

        // }
        // else {
        //     (this.props.field.options || []).map((opt, i) => {
        //         if (opt.optionId !== option.optionId) {
        //             opt.selected = false;
        //         }
        //     });
        // }
    }

    private updateOption(optionId: number, selected: boolean) {
        const formModel = this.props.formComponent.getFormModel<Forms.FormBuilder.FormSubmissionData>();
        let field: Forms.FormBuilder.FormFieldData | undefined;
        for (const s of formModel.data.sections) {
            field = _.find(s.fields, (x) => x.fieldId === this.props.field.fieldId);
            if (field)
                break;
        }

        if (field) {
            const option = _.find((field.options || []), (opt) => opt.optionId === optionId);
            if (option) {
                option.selected = selected;

                const openAnswer = this.state.openAnswer;
                if (option.isOpenAnswer)
                    openAnswer[option.optionId] = selected;

                // uncheck all if not a checklist
                if (field.typeId !== M.FormBuilder.FieldTypes.CheckList.id)
                    (field.options || []).map((opt, i) => {
                        if (opt.optionId !== option.optionId)
                            opt.selected = false;
                    });

                this.props.formComponent.updateFormModel(formModel, () => {
                    this.setState({ ...this.state, openAnswer });
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/formBuilder/editors/SelectListField.tsx